import React from 'react';
import TipIcon from '@material-ui/icons/AttachMoney';
import makeStyles from '@material-ui/core/styles/makeStyles';

const WISH_TIPPING = 'wishTipping';

const tippingIconStyle = makeStyles(theme => ({
  root: {
    color: theme.palette.common.white,
    height: '20px',
    width: '20px',
  },
}));

const TippingMessage = ({ message }) => {
  const classes = tippingIconStyle();

  const isWishTippingMessage = message?.details?.subType === WISH_TIPPING;
  let messageContent;
  let messageHeader;

  if (isWishTippingMessage) {
    messageHeader = 'Gift Notification';
    messageContent = `I've gifted you $${message.details.tipsAmmount} to help fulfill your Tempting Wish`;
  } else {
    messageHeader = 'Tipping Notification';
    messageContent = `I really like the show. I have tipped you $${message.details.tipsAmmount}`;
  }

  return (
    <li className="message tipping-message">
      <div className="tipping-message-container">
        <div className="tipping-message-header">
          <TipIcon className={classes.root} />
          <span className="tipping-message-title">
            {messageHeader}
          </span>
        </div>
        <p>{messageContent}</p>
      </div>
    </li>
  )
};

export default TippingMessage;
